import { AttachmentType } from "@docma-mm-core/attachment/attachment-type";
import { ViewFault } from "@docma-mm-core/fault/fault";

export function getPlanSectionIndexForFault(fault: ViewFault): number {
    const planSections = fault.attachments.filter(f => f.data.Type == AttachmentType.PlanSection).sort((a, b) => (b.data.ModifiedOn ?? b.data.CreatedOn).getTime() - (a.data.ModifiedOn ?? a.data.CreatedOn).getTime());
        
    if(planSections.length > 0) {
        const regex = /\d+/;
        const latestFileName = planSections[0].data.Description || planSections[0].data.OriginalFileName
        const regexResult = latestFileName.match(regex);
        if(regexResult && regexResult.length > 0) {
        return Number(regexResult[0]);
        }
    }  
    return 0;
}